import { faThumbsDown, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type FinishedClerkProps = {
  sendRate: (rate: number) => void;
  rate: number | null;
};

const FinishedClerk: React.FC<FinishedClerkProps> = ({ sendRate, rate }) => {
  return (
    <div className="feedback">
      <span>
        <b>O seu atendimento foi encerrado!</b> <br />
        Como você avalia o nosso atendimento?
      </span>
      <div className="feedbackButtons">
        <button
          style={{ opacity: rate === 1 ? "0.4" : "1" }}
          className="thumbDown"
          onClick={() => {
            sendRate(0);
          }}
          type="button"
        >
          <FontAwesomeIcon icon={faThumbsDown} />
        </button>
        <button
          style={{ opacity: rate === 0 ? "0.4" : "1" }}
          className="thumbUp"
          onClick={() => {
            sendRate(1);
          }}
          type="button"
        >
          <FontAwesomeIcon icon={faThumbsUp} />
        </button>
      </div>
      {rate !== null && (
        <span className="sentFeedback">
          Muito obrigado! Sua avaliação foi enviada para o nosso time!
        </span>
      )}
    </div>
  );
};

export default FinishedClerk;
